import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./lib/i18n"; // initialize i18next before any component renders
import { initAnalytics } from "./lib/analytics";

initAnalytics();

const basename = import.meta.env.VITE_PORTAL_BASE_PATH || "/";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <App basename={basename} />
  </StrictMode>
);
